import { useState, useEffect } from 'react';
import { isNativePlatform } from '@/lib/platform';

export function detectInAppBrowser(): boolean {
  if (typeof window === 'undefined') return false;
  // Capacitor uses WebView on Android; UA includes `wv`, which would falsely match
  // the in-app-browser rule below. Native shell is not Instagram/FB IAB.
  if (isNativePlatform()) return false;

  const ua = navigator.userAgent;
  return (
    /Instagram|FBAN|FBAV|FB_IAB|LinkedIn|Twitter|TikTok|musical_ly|Snapchat|Pinterest|WhatsApp|MicroMessenger/i.test(ua) ||
    (/Android/.test(ua) && /wv/.test(ua))
  );
}

export function useIsInAppBrowser(): boolean {
  const [isInApp, setIsInApp] = useState<boolean>(false);
  useEffect(() => {
    setIsInApp(detectInAppBrowser());
  }, []);
  return isInApp;
}
